












































































import { Facet, Searchable } from '~/models/search/types'
import { computed, defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import CPostcodeAutocomplete from '~/components/shared/configurable/form/autocomplete/CPostcodeAutocomplete.vue'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { Option, TreeOption } from '~/models/shared/types'
import { PostcodeSuggestion } from '~/models/location/postcode'
import CTreeSelect from '~/components/shared/configurable/form/select/tree/CTreeSelect.vue'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CTreeSelect,
    CPostcodeAutocomplete,
    CSlider
  },
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()
    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    const postcodeFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('postcode')
    )

    const selectedPostcode = ref({
      name: postcodeFacet.value?.values?.selected?.postcode || ''
    })
    const selectedPostcodeDistance = ref(
      parseFloat(
        postcodeFacet.value?.values?.selected?.distance ||
          postcodeFacet.value?.searchables[0]?.v
      )
    )
    const selectedLocations = ref(props.selected || [])

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const distanceOptions = computed(() =>
      (postcodeFacet.value?.searchables || []).map((s: Searchable) => ({
        label: s.n,
        value: s.v
      }))
    )

    const selectedDistance = computed(
      () =>
        distanceOptions.value.find(
          (option: Option) => option.value === selectedPostcodeDistance.value
        )?.label
    )

    const locationOptions = computed(() =>
      (props.searchables || []).map(mapLocationSearchables)
    )

    const postcodeIsSelected = computed(() => postcodeFacet.value?.isSelected)

    const locationIsSelected = computed(() => props.isSelected)

    watch(
      () => props.selected,
      (newSelected: any) => {
        selectedLocations.value = newSelected || null
      }
    )

    watch(postcodeFacet, (newPostcodeFacet: Facet) => {
      selectedPostcode.value.name =
        newPostcodeFacet?.values?.selected?.postcode || ''
      selectedPostcodeDistance.value = parseFloat(
        newPostcodeFacet?.values?.selected?.distance ||
          newPostcodeFacet?.searchables[0]?.v
      )
    })

    function mapLocationSearchables(s: Searchable): TreeOption {
      return {
        label: s.n,
        value: s.v,
        count: s.c,
        selected: s.s,
        children: (s.k || []).map(mapLocationSearchables),
        hasChildren: !!s.hc
      }
    }

    function onPostcodeChange(postcodeSuggestion: PostcodeSuggestion) {
      changeParams([
        {
          name: 'postcode',
          value: postcodeSuggestion.name
        },
        {
          name: 'country_code',
          value: postcodeSuggestion.countryCode || null
        }
      ])
    }

    function onPostcodeDistanceChange(distance: number) {
      changeParams([
        {
          name: 'distance',
          value: distance
        }
      ])
    }

    function onLocationChange(locations: number[]) {
      changeParams([
        {
          name: props.urlArgNames[0],
          value: locations
        }
      ])
    }

    function onClearPostcodeButtonClick() {
      selectedPostcode.value.name = ''
      selectedPostcodeDistance.value = postcodeFacet.value?.searchables[0]?.v

      changeParams([
        {
          name: 'postcode',
          value: null
        },
        {
          name: 'country_code',
          value: null
        },
        {
          name: 'distance',
          value: null
        }
      ])
    }

    function onClearLocationButtonClick() {
      selectedLocations.value = []

      changeParams([
        {
          name: props.urlArgNames[0],
          value: null
        }
      ])
    }

    return {
      postcodeFacet,
      loadingFacets,
      selectedLocations,
      selectedPostcodeDistance,
      selectedPostcode,
      distanceOptions,
      locationOptions,
      selectedDistance,
      postcodeIsSelected,
      locationIsSelected,
      onPostcodeChange,
      onPostcodeDistanceChange,
      onClearPostcodeButtonClick,
      onLocationChange,
      onClearLocationButtonClick
    }
  }
})
